__turbopack_context__.v({
  "arrowBase": "GmDVBG_arrowBase",
  "arrowMobile": "GmDVBG_arrowMobile",
  "step": "GmDVBG_step",
  "stepDescription": "GmDVBG_stepDescription",
  "stepNumber": "GmDVBG_stepNumber",
  "wrapper": "GmDVBG_wrapper",
});
